import { useQuery, DocumentNode } from '@apollo/client';
import { useRouter } from 'next/router';

import { getQueryParam } from '../utils/querystring';
import { getSortQuery } from '../utils/sort';
import useServerContext from './useServerContext';
import useUpdateEffect from './useUpdateEffect';

function useAllCardsQuery(ALL_CARDS_PLP_QUERY: DocumentNode) {
  const { query } = useRouter();
  const page = +(query.page || 1);

  const variables = {
    version: 'v2',
    page,
    pageSize: 96,
    ages: getQueryParam(query, 'ages'),
    colors: getQueryParam(query, 'colors'),
    coins: getQueryParam(query, 'coins'),
    designers: getQueryParam(query, 'designers'),
    greetings: getQueryParam(query, 'greetings'),
    photoCounts: getQueryParam(query, 'photo_counts'),
    shapes: getQueryParam(query, 'shapes'),
    themes: getQueryParam(query, 'themes'),
    ...getSortQuery(query),
  };

  // scroll to top of the grid when query params change
  useUpdateEffect(() => {
    const gridElement = document.getElementById('content-grid');
    gridElement?.scrollIntoView();
  }, [JSON.stringify(query)]);

  const { serverContext } = useServerContext();
  const { data, error, loading, previousData } = useQuery(ALL_CARDS_PLP_QUERY, {
    variables,
    context: {
      headers: {
        ...serverContext?.req?.headers,
      },
    },
  });

  const cards = data?.cards || previousData?.cards;
  return { loading, error, cards };
}

export default useAllCardsQuery;
